import type { SVGProps } from "react";

export function CloseMenu(props: SVGProps<SVGSVGElement>) {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="clamp(1.5rem, 1.143rem + 0.952vw, 2rem)"
        height="clamp(1.5rem, 1.143rem + 0.952vw, 2rem)"
        viewBox="0 0 24 24"
        {...props}
      >
        <path
          fill="rgb(255, 252, 252)"
          d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12z"
        ></path>
      </svg>
    </div>
  );
}
